export const SELECT_ALL_VALUE = '__ALL__'

export function withSelectAllOption(items) {
  return [{ text: 'Select All', value: SELECT_ALL_VALUE }, ...(items || [])]
}

// When the user picks the synthetic "Select All" chip, expand the selection to every
// real value instead of leaving "Select All" as a lone chip. Clearing back to none is
// already handled by the v-select's own `clearable` (x) icon.
export function expandSelectAll(newVal, allRealValues) {
  if (Array.isArray(newVal) && newVal.includes(SELECT_ALL_VALUE)) {
    return [...allRealValues]
  }
  return newVal
}



// WEBPACK FOOTER //
// ./src/mixins/filterSelectAll.js